import React from "react";
import { Progress } from "antd";

interface GaugeCardProps {
  title: string;
  value: number;
  total: number;
  color: string;
  stats: {
    label: string;
    value: number;
  }[];
}

const GaugeCard: React.FC<GaugeCardProps> = ({
  title,
  value,
  total,
  color,
  stats,
}) => {
  const percent = (value / total) * 100;

  return (
    <div className="bg-white shadow rounded-xl p-5  h-full flex flex-col">
      <h3 className="text-lg font-semibold">{title}</h3>

      {/* Gauge */}
      <div className="flex justify-center mt-3">
        <Progress
          type="dashboard"
          percent={percent}
          strokeColor={color}
          strokeWidth={12}
          gapDegree={40}
          trailColor="#f2f2f2"
          format={() => ""} // <-- removes percentage text
          size={150}
        />
      </div>

      {/* CENTER VALUE */}
      <div className="text-center -mt-[90px] mb-3">
        <p className="text-3xl font-bold">{value}</p>
        <p className="text-gray-400 text-sm">Out of {total}</p>
      </div>

      {/* STATS LIST */}
      <div className="mt-10 space-y-3">
        {stats.map((item, index) => (
          <div key={index} className="flex justify-between text-sm">
            <span className="text-gray-600">{item.label}</span>
            <span className="font-semibold">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GaugeCard;
